import Heading from '@eversports/react-components/primitives/Heading'
import React from 'react'

import { Localized } from '../../localization/react'

interface Props {
  hasSelfCheckIn: boolean
}

const AppPromotionHeading: React.FC<React.PropsWithChildren<Props>> = ({ hasSelfCheckIn }) => (
  <Heading is="h1" variant="large" textAlign={['center', 'left']} textTransform="uppercase">
    {hasSelfCheckIn ? <Localized id="app-promotion-heading-self-check-in" /> : <Localized id="app-promotion-heading" />}
  </Heading>
)

export default AppPromotionHeading
